var map = {
	"./busd.svg": 2008,
	"./crypto-pending.png": 2009,
	"./crypto-reject.png": 2010,
	"./crypto-success.png": 2011,
	"./direpay.svg": 2012,
	"./trx.svg": 2013,
	"./usdc.svg": 2014,
	"./usdt.svg": 2015
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 153;